import { render, staticRenderFns } from "./ServiceScheduleCreateShiftModal.vue?vue&type=template&id=1587da75&scoped=true&"
import script from "./ServiceScheduleCreateShiftModal.vue?vue&type=script&lang=js&"
export * from "./ServiceScheduleCreateShiftModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceScheduleCreateShiftModal.vue?vue&type=style&index=0&id=1587da75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1587da75",
  null
  
)

export default component.exports